module.exports = __webpack_public_path__ + "img/6.4548a6cd.png";